import { OpaqueToken } from '@angular/core';

// import translations
import { LANG_WebShop_NAME, LANG_WebShop_TRANS } from './lang-webshop';

// translation token
export const TRANSLATIONS = new OpaqueToken('translations');

// all translations
export const dictionary = {
    [LANG_WebShop_NAME]: LANG_WebShop_TRANS,
};

// providers
export const TRANSLATION_PROVIDERS = [
    { provide: TRANSLATIONS, useValue: dictionary },
];


// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/translate/translations.ts